import Cookie from "js-cookie";
import { Loading } from "element-ui";
import { getLanguage } from '@/lang/index'
import store from '@/store'

// import VueRouter from 'vue-router'
// import main from '@/views/rms86/main.vue'
// import login from '@/views/rms86/login'
// import login_error from '@/views/rms86/login/login_error'
// import tutorialView from '@/views/rms86/JobTutorial/JobTutorial_view'
// import tutorialView導致 JobTutorial_view頁面顯示不正常

// es6语法
export default {
  state: {
    isCollapse: false, // 控制菜单的展开与收起
    tabList: [
      {
        path: "/",
        name: "home",
        label: "_home_page",
        icon: "s-home",
        url: "home/home",
      },
    ],
    menu: [],
    // 面包屑数据
    breadcrumbList: [
      {
        path: "/",
        name: "home",
        label: "_home_page",
        icon: "s-home",
        url: "home/home",
      },
    ],
    // 當前tab名稱(用於lookup動態名稱)
    current_label: "",
    // 如果左側菜單點擊時，監測到tabList存在對應路由的新增/修改頁面時切換到Tab
    next_label: "",
    //接口請求次數
    apiCount: 0,
    loadingLockCount: 0,
    //loading實例
    loadingInstance: null,
    // 當前多語言
    language: getLanguage(),
    // 當前頁面高度
    current_height: "",
    // 當前字體大小
    size: Cookie.get("size") || "Medium",
    // 當前分页布局
    current_layout: "",
    // 當前弹窗高度
    current_width: "",
    //是否已自動打開和跳轉到指定頁面(如 sales 時自動打開 sales_call頁面)
    auto_open_menu_num: 0,
    //是否已自動打開和跳轉到打卡頁面(如 sales 時自動打開 sales_call頁面)
    auto_open_clock_num: 0,
    // 當前底部樣式
    current_footer: "",
    // 當前頁面緩存集合
    cachedViews: [],
    // 默認所有lookup type參數用於區分緩存頁
    current_lookup_list: ["JobTemplate_sub_cate", "JobTemplate_cate", "Tutorial_sub_cate", "Tutorial_cate", "Setup_job_edit", "Cust_info_edit","Part_type","Setup_Part_quotation_edit"],
    // 獲取當前tab_code(選項卡被翻譯的m_code)
    current_tab_code: "",
    // 當前選項卡緩存
    current_tab_cache: [],
    // 滾動高度，用在Set_job/Index.vue顯示右側明細
    main_top: 0,
    // 當前頁面高度，帶px結尾
    current_width_page: "",

    // 當前菜單主題
    current_menu_theme: {},
    // 當前導航主題
    current_nav_theme: {},
    // 當前頁面主題
    current_body_theme: {},
    // 當前頁面交叉背景
    current_body_theme_striped: {},

    //緩存離開頁面的滾動位置
    scrollTop_Save: [],
  },
  mutations: {
    get_auto_open_menu_num(state, val) {
      state.auto_open_menu_num = val;
    },
    get_auto_open_clock_num(state, val) {
      state.auto_open_clock_num = val;
    },
    // 修改菜单展开收起
    collapseMenu(state) {
      state.isCollapse = !state.isCollapse;
    },
    // 獲取當前tab名稱
    get_current_label(state, val) {
      state.current_label = val;
    },
    set_next_label(state, val) {
      state.next_label = val;
    },
    // 獲取當前tab_code
    get_tab_code(state, val) {
      state.current_tab_code = val;
    },
    // 更新面包屑数据
    // val使用對象傳參{item:item,type:1 }--type用於區分保存退出更新還是菜單點擊更新
    selectMenu(state, val) {
      // 切換選項卡時增加頁面緩存
      store.dispatch('addCachedView', val.item)
      // 判断添加的数据是否为首页
      if (val.item.name !== "home") {
        const index = state.tabList.findIndex((item) => item != null && item.name === val.item.name);
        // 如果不存在
        if (index === -1) {
          if (val.type === 1)
            state.tabList.push(val.item);
          else {
            // 替換選項卡
            var add_index = state.tabList.findIndex(item => item === null);
            state.tabList[add_index] = val.item;
          }
        }
        // 处理面包屑增加多个Bug
        const breadcrumb_index = state.breadcrumbList.findIndex(
          (item) => item.name === val.item.name
        );
        const del_index = state.breadcrumbList.findIndex(
          (item) => item.name !== "home"
        );
        if (breadcrumb_index === -1) {
          if (del_index != -1) {
            state.breadcrumbList.splice(del_index, 1);
          }
          state.breadcrumbList.push(val.item);
        }
      }
      // 处理非Home页面面包屑不变化
      else {
        const del_index = state.breadcrumbList.findIndex(
          (item) => item.name !== "home"
        );
        if (del_index != -1) {
          state.breadcrumbList.splice(del_index, 1);
        }
      }
    },
    // 删除指定的tag数据
    closeTag(state, obj) {
      const index = state.tabList.findIndex((val) => val != null && val.name === obj.item.name);
      if (index != -1) {
        if (obj.type === 1) {
          state.tabList.splice(index, 1);
          // 刪除選項卡緩存
          store.commit('del_tab_cache', { name: obj.item.name })
        }
        else
          // 替換選項卡
          state.tabList[index] = null;
      }
      // 關閉選項卡移除頁面緩存
      store.dispatch('delCachedView', { name: obj.item.name })
    },
    // 设置menu的数据
    setMenu(state, val) {
      state.menu = val;
      // 将store取到的菜单数据，通过cookie持久化(避免刷新丢失)
      //Cookie.set("menu",JSON.stringify(val));
      localStorage.setItem("menu", JSON.stringify(val));
    },
    // 动态注册路由(解决无权限页面,通过地址访问的bug)
    addMenu(state, router) {
      // 判断当前缓存是否有数据
      //if (!Cookie.get("menu")) return;
      if (!localStorage.getItem("menu")) return;
      const menu = JSON.parse(localStorage.getItem("menu"));
      state.menu = menu;
      // 组装动态路由的数据
      const menuArray = [];
      // 遍历后端获取的菜单
      menu.forEach((item) => {
        if (item.children) {
          // 添加子菜单路由
          item.children = item.children.map((item) => {
            if (state.current_lookup_list.indexOf(item.name) != -1) {
              item.component = () => dynamicRouteComponent(import(`@/views/rms86/${item.url}`), item.name);
            }
            else {
              item.component = () => import(`@/views/rms86/${item.url}`);
            }
            return item;
          });
          menuArray.push(...item.children); //箭头函数可使用扩展运算符取值
        } else {
          if (item.meta != null && item.meta.istrun == true) {
            item.component = () => dynamicRouteComponent(import(`@/views/rms86/${item.url}`), item.name);
          }
          else {
            item.component = () => import(`@/views/rms86/${item.url}`);
          }
          menuArray.push(item);
        }
      });
      // 路由的动态添加，(Bug只添加不刪除無權限的路由)
      const allRoutes = router.getRoutes();
      menuArray.forEach((item) => {
        if(allRoutes.findIndex((it)=>item.name === it.name) === -1)
        {
          if(item.url=="Setup_dns_records/SetDnsMobile") {
            router.addRoute("main", item);
            //router.addRoute("/", item); //一些初始化在Home中，不可以直接導航到SetDnsMobile
          }
          else if(item.url=="android_auth/Index") {
            router.addRoute("main", item);
          }
          else {            
            router.addRoute("main", item);
          }
        }
      });

      // //重新建立路由
      // var routes = [
      //   // 主路由
      //   {
      //     path: '/',
      //     name: 'main',
      //     component: main,
      //     redirect: '/home',// 重定向(首页默认为home)
      //   },
      //   {
      //     path: '/login',
      //     name: 'login',
      //     component: login
      //   },
      //   {
      //     path: '/login_error',
      //     name: 'login_error',
      //     component: login_error
      //   },
      //   {
      //     path: '/redirect',
      //     name: 'redirect',
      //     component: main,
      //     /*   meta: {
      //         istrun: true // 默认隐藏路由
      //       }, */
      //     children: [
      //       {
      //         path: '/redirect/:path(.*)',
      //         component: () => import('@/views/rms86/redirect')
      //       }
      //     ]
      //   },
      //   {
      //     path: '/JobTutorial_view',
      //     name: 'JobTutorial_view',
      //     component: tutorialView,
      //     meta: {
      //       istrun: true // 默认隐藏路由
      //     },
      //   },
      // ]
      // var newRouter = new VueRouter({
      //   mode: 'hash',
      //   routes // 公共路由
      // })

      // // 替換現有router的routes
      // router.matcher = newRouter.matcher;
      // menuArray.forEach((item) => {
      //   router.addRoute("main", item);
      // });
    },
    // 追加新路由
    addNewRoute(state, val) {
      const index = state.tabList.findIndex((item) => item != null && item.name === val.name);
      if (index === -1) {
        //state.tabList.push(val);
        // 替換選項卡
        var add_index = state.tabList.findIndex(item => item === null);
        state.tabList[add_index] = val;
      }
      // 更新面包屑
      const del_index = state.breadcrumbList.findIndex(
        (item) => item.name !== "home"
      );
      const breadcrumb_index = state.breadcrumbList.findIndex(
        (item) => item.name === val.name
      );
      if (breadcrumb_index === -1) {
        if (del_index != -1) {
          state.breadcrumbList.splice(del_index, 1);
        }
        state.breadcrumbList.push(val);
      }
    },
    // 打開Loading
    showloading(state) {
      if (state.loadingInstance) return;
      state.loadingInstance = Loading.service({
        lock: true,
        background: 'rgba(0, 0, 0, 0.4)'
      });
    },
    // 關閉Loading
    hideloading(state) {
      if (!state.loadingInstance) return;
      state.loadingInstance.close();
      state.loadingInstance = null;
    },
    beginBatchLoading(state) {
      state.loadingLockCount++;
      this.commit("showloading");
    },
    endBatchLoading(state) {
      if (state.loadingLockCount > 0) {
        state.loadingLockCount--;
      }
      if (state.loadingLockCount <= 0 && state.apiCount <= 0) {
        this.commit("hideloading");
      }
    },
    // 更新請求執行緒池
    updateApiCount(state, handle) {
      if (handle == "add") {
        state.apiCount++;
        this.commit("showloading");
      } else {
        state.apiCount--;
        if (state.apiCount < 0) {
          state.apiCount = 0;
        }
        if (state.apiCount <= 0 && state.loadingLockCount <= 0) {
          this.commit("hideloading");
        }
      }
    },
    // 設置多語言
    set_language: (state, language) => {
      state.language = language
      // 更新多语言cookie
      Cookie.set(Cookie.get("current_login_id") + "language_code", language)
      // 更新多語言ID
      Cookie.set(Cookie.get("current_login_id") + "language_id", language === "eng" ? "1" : (language === "cht" ? "2" : "3"))
    },
    // 獲取當前頁面高度
    get_current_height(state, val) {
      state.current_height = val;
    },
    // 設置字體大小
    set_size(state, val) {
      state.size = val;
      // 更新字體大小cookie
      Cookie.set("size", val)
    },
    // 设置分页布局
    get_current_layout(state, val) {
      state.current_layout = val;
    },
    // 设置弹窗高度
    get_current_width(state, val) {
      state.current_width = val;
    },
    get_current_access_width(state, val) {
      state.current_access_width = val;
    },
    // 設置底部樣式
    get_current_footer(state, val) {
      state.current_footer = val;
    },
    // 增加頁面緩存
    add_cached_view: (state, view) => {
      if (state.cachedViews.includes(view.name)) return
      state.cachedViews.push(view.name)
    },
    // 刪除頁面緩存
    del_cached_view: (state, view) => {
      const index = state.cachedViews.indexOf(view.name)
      index > -1 && state.cachedViews.splice(index, 1)
    },
    // 增加選項卡緩存
    add_tab_cache: (state, view) => {
      // 重複緩存更新 
      const index = state.current_tab_cache.findIndex(item => item.name === view.name.replace("_edit", ""));
      if (index > -1) {
        if (view.IsSave === 0)
          state.current_tab_cache[index] = view;
        else {
          state.current_tab_cache[index].IsSave = view.IsSave;
          state.current_tab_cache[index].pageData.page = 1;
        }
      }
      else
        state.current_tab_cache.push(view)
    },
    // 刪除選項卡緩存
    del_tab_cache: (state, view) => {
      const index = state.current_tab_cache.findIndex(m => m.name === view.name.replace("_edit", ""))
      index > -1 && state.current_tab_cache.splice(index, 1)
    },
    set_main_top: (state, val) => {
      state.main_top = val
    },
    set_current_width_page(state, val) {
      state.current_width_page = val;
    },

    // 更新菜單主題
    set_menu_theme(state, val) {
      state.current_menu_theme = val;
    },
    // 更新導航主題
    set_nav_theme(state, val) {
      state.current_nav_theme = val;
    },
    // 更新頁面主題
    set_body_theme(state, val) {
      state.current_body_theme = val;
    },
    set_body_theme_striped(state, val) {
      state.current_body_theme_striped = val;
    },

    set_tab_scrollTop(state, val) {
      //刪除重複項
      const index = state.scrollTop_Save.findIndex(m => m.key === val.key);
      index > -1 && state.scrollTop_Save.splice(index, 1);
      state.scrollTop_Save.push(val);
    },
    del_tab_scrollTop(state, key) {
      //刪除指定Tab的滾動緩存
      const index = state.scrollTop_Save.findIndex(m => m.key === key);
      index > -1 && state.scrollTop_Save.splice(index, 1);
    },
  },
  // 可使用this.$store.dispatch({ commit },val)--异步存储,值会动态变化
  // 可使用this.$store.commit({ commit },val)--同步存储,值不会动态变化
  actions: {
    setLanguage({ commit }, language) {
      commit('set_language', language)
    },
    setSize({ commit }, size) {
      commit('set_size', size)
    },
    addCachedView({ commit }, view) {
      commit('add_cached_view', view)
    },
    delCachedView({ commit }, view) {
      commit('del_cached_view', view)
    },
  },
  // 變量引用
  getters: {
    language: state => state.language,
    current_height: state => state.current_height,
    current_width: state => state.current_width,
    current_width_page: state => state.current_width_page,
    size: state => state.size,
    current_layout: state => state.current_layout,
    current_footer: state => state.current_footer,
    el_main_top: state => state.main_top,
    current_tab_cache: state => state.current_tab_cache,
    current_menu_theme: (state) => state.current_menu_theme,
    current_nav_theme: (state) => state.current_nav_theme,
    current_body_theme: (state) => state.current_body_theme,
    current_body_theme_striped: (state) => state.current_body_theme_striped,

    get_tab_scrollTop: (state) => (key) => {
      const index = state.scrollTop_Save.findIndex(m => m.key === key);
      if (index > -1) {
        return state.scrollTop_Save[index].value;
      }
      return null;
    },
  },
};

export function dynamicRouteComponent(componentOptions, routeName) {
  const clone = (comp) => {
    if (comp && comp.default) {
      return { ...comp.default, name: routeName }
    }
    return comp
  }

  if (componentOptions instanceof Promise) {
    // 异步组件
    return componentOptions.then((comp) => {
      return clone(comp)
    })
  } else {
    // 同步组件
    return clone(componentOptions)
  }
}
